export default __webpack_public_path__ + "static/media/tvpublica_logo_2021.cf73c522.bmp";